var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"logo"},[_c('ApparatLogoWhite')],1),_c('SanityBlockContent',{attrs:{"content":_vm.content}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }